{{label}}
<span *ngIf="!required" class="optional" i18n>*Optional</span>
<div class="container">
  <listo-select [value]="month" [options]="months" (change)="onMonthChange($event)" placeholder="MM" [required]="true"></listo-select>
  <listo-select [value]="day" [options]="days" (change)="onDayChange($event)" placeholder="DD" [required]="true"></listo-select>
  <listo-select class="time" [value]="hour" [options]="hours" (change)="onHourChange($event)" i18n-placeholder placeholder="Preferred time" [required]="true"></listo-select>
</div>
